// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Phone from "@insite/mobius/Icons/Phone";
import { locationSearchFormStyles } from "@vanmeter/Overrides/Components/LocationSearchForm";
import { fontConfig } from "@vanmeter/XDL/constants";
import { createLinkIconStyles, mergeWithCss } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

locationSearchFormStyles.distanceUnitOfMeasureRadioGroup = {
    ...mergeWithCss(locationSearchFormStyles.distanceUnitOfMeasureRadioGroup, {
        css: css`
            &&& {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: flex-end;
                gap: 16px;
            }
        `,
    }),
};

locationSearchFormStyles.locationDisplayNumberText = {
    color: "primary",
    weight: fontConfig.weight.bold,
    ...fontConfig.regularSingleLine,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem =
    locationSearchFormStyles.searchResultPhoneGridItem =
    locationSearchFormStyles.searchResultDistanceGridItem =
        {
            width: [6, 6, 4, 4, 4],
        };

locationSearchFormStyles.searchResultPhoneLink = {
    ...createLinkIconStyles({ icon: Phone, sizeVariant: "small" }),
};

locationSearchFormStyles.locationDistanceDisplayText = {
    ...fontConfig.smallSingleLine,
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
};

locationSearchFormStyles.pagination = {
    cssOverrides: {
        linkList: css`
            &&&&& {
                justify-content: center;
            }
        `,
    },
};
